export * from './premium-alert'
export * from './error-snackbar'
export * from './auth-modal'
export * from './image-popover'
export * from './background/rectangle-network'

export const reactRootElement = document.getElementById(
  'root',
) as HTMLDivElement
